'use client'

import FollowUpScrubber from './FollowUpScrubber'

// Home services: a quoted estimate followed up on the page's own schedule
// (SMS day 1, email day 3, voice day 7, SMS day 14, email day 30), and a
// recurring service visit that ends with a review request "while customers
// are still happy with the work".

const SCENARIOS = {
  estimate: {
    tab: 'Estimate follow-up',
    person: { initials: 'RT', name: 'Rachel Torres', detail: 'Estimate sent: water heater replacement, $3,850', status: 'Estimate pending' },
    startDay: 0,
    maxDay: 30,
    dayLabel: (d) => (d === 0 ? 'Sent' : `Day ${d}`),
    idle: 'Estimate sent. Rachel is comparing quotes…',
    touches: [
      { day: 1, channel: 'sms', label: 'Text check-in', message: 'Hi Rachel, did the water heater estimate make sense? Reply here with any questions.' },
      { day: 3, channel: 'email', label: 'Estimate recap', message: 'Your $3,850 quote, what is included, and our next open install dates.' },
      { day: 7, channel: 'voice', label: 'Voicemail drop', message: 'A short recorded follow-up from the owner.' },
      { day: 14, channel: 'sms', label: 'Text reminder', message: 'We can still install this week. Want us to hold a slot?' },
      { day: 30, channel: 'email', label: 'Last check-in', message: 'Still thinking it over? Your quote is saved.' },
    ],
    reply: { day: 8, text: "Let's go ahead. Is Thursday possible?", status: 'Approved: $3,850', stamp: 'Estimate approved · day 8' },
  },
  recurring: {
    tab: 'Recurring service',
    person: { initials: 'GP', name: 'Greg Patel', detail: 'Lawn care every two weeks', status: 'Visit on Thursday' },
    startDay: -2,
    maxDay: 4,
    dayLabel: (d) => (d === 0 ? 'Service day' : d < 0 ? `${-d} days before` : `Day ${d}`),
    idle: 'Two days before the next visit…',
    touches: [
      { day: -2, channel: 'sms', label: 'Visit reminder', message: 'Hi Greg, your lawn service is Thursday morning. Reply R to reschedule.' },
      { day: 0, channel: 'sms', label: 'On our way', message: 'Your crew is on the way, arriving in about 20 minutes.' },
      { day: 1, channel: 'review', label: 'Review request', message: 'Thanks for having us! Would you leave a quick review?' },
      { day: 3, channel: 'sms', label: 'Review nudge', message: 'Just a reminder: your review helps neighbours find us.' },
    ],
    reply: { day: 2, text: 'Left you 5 stars, great job as always.', status: 'Reviewed: 5 stars', stamp: 'New 5-star review' },
  },
}

export default function HomeServicesFollowUp() {
  return (
    <FollowUpScrubber
      title="Every estimate and visit, followed up"
      label="Demo: automated estimate follow-up and recurring service messages for a home services business"
      scenarios={SCENARIOS}
    />
  )
}
